module.exports = "img/taller-ing-3.5f478c.jpg";